import { Injectable } from '@angular/core';
import { Observable, fromEvent } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WindowService {

  constructor() { }

  resizeObservable$: Observable<Event> = fromEvent(window, 'resize');

}
